import {
  AUTH_LOADING_USER_DATA_ACTION,
  AUTH_LOAD_USER_DATA_ERROR_ACTION,
  AUTH_LOAD_USER_DATA_SUCCESS_ACTION,
  AUTH_SET_PERMISSIONS,
} from './AuthActions';
import { NoProfilePermissions } from './permissions/NoProfile';

const INITIAL_STATE = {
  loadingUserData: false,
  accessToken: null,
  tokenType: null,
  userPermissions: NoProfilePermissions,
  userData: null,
};

export default function AuthReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_SET_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    case AUTH_LOADING_USER_DATA_ACTION:
      return {
        ...state,
        loadingUserData: action.payload,
      };
    case AUTH_LOAD_USER_DATA_SUCCESS_ACTION:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        tokenType: action.payload.tokenType,
        userData: action.payload.dadosUsuario,
      };
    case AUTH_LOAD_USER_DATA_ERROR_ACTION:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}
